import { call, getContext, put, select, takeEvery } from 'redux-saga/effects';
import {
  patterns as patternsExperiences,
  themeUpdate,
} from 'entities/experiences';
import { selectCanonicalExperience } from 'entities/history-log';
import { stripThemeStyles, updateStepGroupToTheme } from 'lib/themes';
import { patterns, reject, resolve } from './actions';
import { selectCurrentTheme } from './reducer';

function* fetchCompiledTheme({ payload }) {
  const {
    experience: { theme: themeId },
  } = payload;

  if (!themeId) {
    // If it's a new experience that explicity doesn't have a theme, remove the saved theme
    yield put(resolve(null));
    return;
  }

  const currentTheme = yield select(selectCurrentTheme);
  if (currentTheme?.id === themeId) {
    return;
  }

  const logger = yield getContext('logger');
  try {
    const api = yield getContext('api');
    const response = yield call(api.getCompiledTheme, themeId);
    yield put(resolve(response));
  } catch (error) {
    yield put(reject(error));
    logger.error(error);
  }
}

function* changeTheme({ payload }) {
  const { theme: themeId } = payload;

  const logger = yield getContext('logger');
  try {
    const api = yield getContext('api');
    const response = yield call(api.getCompiledTheme, themeId);

    const { steps } = yield select(selectCanonicalExperience);
    const rethemedSteps = steps.map(step => {
      // 1. updateStepGroupToTheme, injecting the theme value while preserving the current styles
      const updatedStepGroup = updateStepGroupToTheme({
        stepGroup: step,
        compiledTheme: response,
        preserveOverrides: true,
      });

      // 2. stripThemeStyles, removing the styles that currently match the theme so that only actual overrides remain
      //    (ensuring there's no unexpected results if the theme values change)
      return stripThemeStyles(response, updatedStepGroup);
    });

    const updatedExperience = {
      ...payload,
      steps: rethemedSteps,
    };
    yield put(themeUpdate(updatedExperience));
    yield put(resolve(response));
  } catch (error) {
    yield put(reject(error));
    logger.error(error);
  }
}

export default function* saga() {
  yield takeEvery(
    [patternsExperiences.resolve, patternsExperiences.insert],
    fetchCompiledTheme
  );
  yield takeEvery(patterns.update, changeTheme);
}
